import React from 'react';

import { useNavigate } from 'react-router-dom';

import { reverse } from 'named-urls';

import { GridEventListener, GridRowParams } from '@mui/x-data-grid';

import Record from 'ui/Record/Record';

import { MainHeader } from 'components/MainHeader/MainHeader';

import { Button } from 'components/Button';

import Grid from 'components/Grid';

import { VatixError } from 'components/Error/types';

import routes from 'core/routes';

import { useNavBarHeight } from 'utils/hooks/navbar';

import { basicColumns } from './components/columns';

const MemberGroupsGrid: React.FunctionComponent<{ onError: (error: VatixError) => void }> = ({ onError }) => {
  const navigate = useNavigate();

  const onRowClick: GridEventListener<'rowClick'> = ({ row }: GridRowParams): void => {
    navigate(reverse(routes.dashboard.settings.groups.details, { groupId: row.uuid }));
  };

  return (
    <Grid
      key="member_groups_grid"
      basicColumns={basicColumns}
      dataURL="member-groups/"
      onError={onError}
      onRowClick={onRowClick}
      sortBy={{ field: 'name', sort: 'asc' }}
      customNoRowsText="No groups to show"
      disableColumnSelector
      disableExport
    />
  );
};

const MemberGroups: React.FunctionComponent = (): React.ReactElement => {
  const navigate = useNavigate();
  const navBarHeight = useNavBarHeight();

  return (
    <Record
      key="member_groups"
      Header={
        <MainHeader
          title="Groups"
          breadcrumbs={[
            { label: 'Organisation', link: '' },
            { label: 'Groups', link: routes.dashboard.settings.groups.toString() },
          ]}
          action={
            <Button
              size="large"
              variant="contained"
              onClick={() => navigate(routes.dashboard.settings.groups.new.toString())}
            >
              New group
            </Button>
          }
        />
      }
      Content={(onError) => <MemberGroupsGrid onError={onError} />}
      navBarHeight={navBarHeight}
    />
  );
};

export default MemberGroups;
